import { ReactElement } from 'react';

import { SubtitleItem, SubtitleItemProps } from './Item';

type SubtitleProps = {
  children: ReactElement<SubtitleItemProps> | ReactElement<SubtitleItemProps>[];
};

export const Subtitle = ({ children }: SubtitleProps) => {
  return <div className="subtitles">{children}</div>;
};

Subtitle.Item = SubtitleItem;
